<div class="_wait-list-desktop-page">

    
    <table-desktop-component 
        [headers]="tableHeaders"
		[filters]="tableFilters"
		[dataRequest]="dataRequest" 
        (dataChanged)="dataChanged($any($event))"  
		stateKey="wait-list-items"
	>

		<button *ifUserHasPermissions="[UserPermissions.WriteWaitList]" type="button" button class="_button _add-button" (click)="createOrUpdate()">
			<ion-icon src="./assets/icons/add-outline.svg"></ion-icon>
			<span>{{ 'WAIT_LIST.CREATE' | translate}}</span>
		</button>

		<ion-row data class="_row _data ion-align-items-center" *ngFor="let waitListItem of waitListItems" [ngClass]="{
			'_requested': waitListItem.status === WaitListItemStatus.Requested, 
			'_resolved': waitListItem.status === WaitListItemStatus.Resolved,
			'_dismissed': waitListItem.status === WaitListItemStatus.Dismissed,  
		}">
			<table-col [size]="2">
                {{waitListItem.createdAt | date}} 
			</table-col>
			<table-col [size]="2">
				{{'WAIT_LIST.STATUS.' + waitListItem.status | uppercase | translate }} 
			</table-col> 	
			<table-col [size]="3">
                {{ waitListItem.type }} <br>
				<span style="color:grey">{{waitListItem.Event?.name}}</span>
			</table-col> 
			<table-col [size]="2">
                {{waitListItem.description}} 
			</table-col>			
			<table-col [size]="3">
                <b>{{waitListItem.Client.firstname}} {{waitListItem.Client.lastname}}</b><br>
				<span *ngIf="waitListItem.Client.Address">{{waitListItem.Client.Address | address}}<br></span>
				<span *ngIf="waitListItem.Client.telephone">{{waitListItem.Client.telephone}}<br></span>
				<span *ngIf="waitListItem.Client.email">{{waitListItem.Client.email}}</span>
			</table-col>
			<table-col [size]="2">
                {{waitListItem.CreatedBy.email}} 
			</table-col>			
			<table-col [size]="1" class="_center">
				<button *ifUserHasPermissions="[UserPermissions.WriteWaitList]" type="button" class="_button _info-button" (click)="createOrUpdate(waitListItem)" title="{{ 'WAIT_LIST.EDIT' | translate}}">
					<ion-icon src="./assets/icons/edit-outline-simple.svg"></ion-icon>
				</button>
			</table-col>                                 
		</ion-row>
	</table-desktop-component>


</div>